export function objectPath<T = unknown>(object: Object, path: string | string[]): T {
  if (typeof object !== 'object') return undefined;
  const [first, ...remainder] = typeof path === 'string' ? path.split('.') : path;
  if (remainder.length) {
    return objectPath<T>(object[first], remainder);
  }
  return object[first] as T;
}
